module.exports = __webpack_public_path__ + "img/Women’s Multivitamin.19a28a9d.png";